import React from 'react';
import graphql from 'graphql';
import Helmet from 'react-helmet';

import Content, { HTMLContent } from '../components/Content';
import PageDetail from '../components/Content';

export const PageTemplate = ({ title, content, contentComponent, helmet }) => {
  const PageContent = contentComponent || Content;

  return (
    <section className="section">
      {helmet || ''}
      <div className="row">
        <div className="col-md-12">
          <article className="pageDetail">
            <h2 className="pageDetail__title">{title}</h2>
            <div className="pageDetail__text">
              <PageContent content={content} />
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default ({ data }) => {
  const { markdownRemark: page } = data;

  return (
    <PageTemplate
      title={page.frontmatter.title}
      content={page.html}
      contentComponent={HTMLContent}
      helmet={<Helmet title={`DUKIM s.r.o. | ${page.frontmatter.title}`} />}
    />
  );
};

export const pageQuery = graphql`
  query PageQuery($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/page.js